import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center pb-3" }
const _hoisted_2 = { class: "relative w-1/4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search absolute top-2/4 mt-[-6px] left-3 text-surface-400" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "flex flex-wrap items-center mb-10"
}
const _hoisted_5 = {
  class: "flex p-0.25 items-center",
  style: {"width":"190px"}
}
const _hoisted_6 = ["for"]
const _hoisted_7 = {
  key: 1,
  class: "w-full flex pb-6 pt-6"
}

import { inject, ref, Ref } from "vue";
import Checkbox from 'primevue/checkbox';
import ProgressSpinner from 'primevue/progressspinner';
import InputText from 'primevue/inputtext';
import type { DynamicDialogInstance } from 'primevue/dynamicdialogoptions'


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltersDialog',
  setup(__props) {


const dialogRef = inject<Ref<DynamicDialogInstance>>('dialogRef')
const params = dialogRef?.value.data;
const searchText = ref("")


function onSubmit() {
    dialogRef?.value.close();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _hoisted_3,
        _createVNode(_unref(InputText), {
          modelValue: searchText.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
          class: "py-0 my-1.5 text-center rounded-md border-2 !shadow-none w-full min-w-fit h-6 outline-none",
          placeholder: "Search"
        }, null, 8, ["modelValue"])
      ])
    ]),
    (_unref(params).dataObject.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(params).dataObject, (dataValue) => {
            return (_openBlock(), _createElementBlock("div", {
              key: dataValue[_unref(params).objectId]
            }, [
              _withDirectives(_createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Checkbox), {
                  class: "border m-1",
                  modelValue: _unref(params).dataModel.selectedFilters[_unref(params).subcat][_unref(params).path].selected,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(params).dataModel.selectedFilters[_unref(params).subcat][_unref(params).path].selected) = $event)),
                  inputId: dataValue[_unref(params).objectId],
                  name: "props.header",
                  value: dataValue
                }, null, 8, ["modelValue", "inputId", "value"]),
                _createElementVNode("label", {
                  for: dataValue[_unref(params).objectId],
                  class: "text-a cursor-pointer"
                }, _toDisplayString(dataValue[_unref(params).objectName]), 9, _hoisted_6)
              ], 512), [
                [_vShow, searchText.value === '' || dataValue[_unref(params).objectName].toUpperCase().includes(searchText.value.toUpperCase())]
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_unref(ProgressSpinner), {
            class: "justify-center w-90 h-90",
            "attrs-color-black": "",
            strokeWidth: "5",
            animationDuration: "1s",
            "aria-label": "Loading"
          })
        ])),
    _createElementVNode("div", {
      class: "absolute flex justify-end bottom-1 bg-white",
      style: {"width":"94%"}
    }, [
      _createElementVNode("button", {
        class: "bg-[#36a8dd] hover:bg-sky-600 text-white font-bold py-1 px-4 rounded place-content-end my-2",
        onClick: onSubmit
      }, " Close ")
    ])
  ], 64))
}
}

})